import { render, staticRenderFns } from "./ImportProductDisplayName.vue?vue&type=template&id=2d1c8946&scoped=true"
import script from "./ImportProductDisplayName.vue?vue&type=script&lang=js"
export * from "./ImportProductDisplayName.vue?vue&type=script&lang=js"
import style0 from "./ImportProductDisplayName.vue?vue&type=style&index=0&id=2d1c8946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c8946",
  null
  
)

export default component.exports